export default __webpack_public_path__ + "static/background-c941615a9a6770ef9fe2337c28798bfd.png";